import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  error: null,
  locations: [],
  gstOnParts: null,
  selectedLocation: "",
  selectedLocationCode: "",
  partsCategories: [],
  vendorsListDetails: {
    loading: false,
    vendorsList: []
  }
};

const configRequestStart = (state) => ({ ...state, error: null, loading: true });

const configRequestSuccess = (state, action) => ({
  ...state,
  loading: false,
  error: null,
  ...action.data
});

const configRequestFail = (state, action) => ({ ...state, error: action.error, loading: false });

const setSelectedLocation = (state, action) => ({
  ...state,
  selectedLocation: action.location?.name,
  selectedLocationCode: action.location.code
});

const fetchOrderVendorStart = (state) => ({
  ...state,
  vendorsListDetails: {
    loading: true
  }
});

const fetchOrderVendorSuccess = (state, action) => ({
  ...state,
  vendorsListDetails: {
    loading: false,
    vendorsList: action.data
  }
});

const fetchOrderVendorFail = (state) => ({
  ...state,
  vendorsListDetails: {
    loading: false
  }
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PIM_CONFIG_REQUEST_START:
      return configRequestStart(state, action);

    case actionTypes.PIM_CONFIG_REQUEST_SUCCESS:
      return configRequestSuccess(state, action);

    case actionTypes.PIM_CONFIG_REQUEST_FAIL:
      return configRequestFail(state, action);

    case actionTypes.SET_SELECTED_LOCATION:
      return setSelectedLocation(state, action);

    case actionTypes.FETCH_ORDER_VENDOR_START:
      return fetchOrderVendorStart(state, action);

    case actionTypes.FETCH_ORDER_VENDOR_SUCCESS:
      return fetchOrderVendorSuccess(state, action);

    case actionTypes.FETCH_ORDER_VENDOR_FAIL:
      return fetchOrderVendorFail(state, action);
    default:
      return state;
  }
};

export default reducer;
